<script lang="ts">
    import type { SvelteComponent } from 'svelte';
    import Modal from '@amp/web-app-components/src/components/Modal/Modal.svelte';
    import ErrorModal from '@amp/web-app-components/src/components/Modal/ErrorModal.svelte';
    import { warningState } from '@amp/web-app-components/src/stores/warning';

    export let dialogTitleId: string | null = null;

    const modalTriggerElement = null;
    let modalElement: SvelteComponent;

    $: if (modalElement && $warningState?.currentWarning) {
        modalElement.showModal();
    }

    async function handleActionButton(isOk: boolean) {
        if (typeof $warningState.currentWarning?.resolveCb === 'function') {
            $warningState.currentWarning?.resolveCb(isOk);
        }

        warningState.set({ currentWarning: null });
        modalElement.close();
    }
</script>

<Modal
    {modalTriggerElement}
    bind:this={modalElement}
    error={true}
    ariaLabelledBy={dialogTitleId}
>
    <ErrorModal
        header={$warningState.currentWarning?.header}
        message={$warningState.currentWarning?.message}
        action={$warningState.currentWarning?.actionText}
        confirm={$warningState.currentWarning?.confirmText}
        buttonLayout={$warningState.currentWarning?.buttonLayout}
        {dialogTitleId}
        on:close={() => handleActionButton(false)}
        on:action={() => handleActionButton(true)}
    />
</Modal>
